import React, { useState, useEffect } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { useLocation } from 'react-router-dom';

import Header from 'common/js/header/header.js';
import 'common/css/master.css';
import HeaderPtmClassSection from 'sms/ptm/js//HeaderPtmClassSection';

import { getClassListSvc, getSectionData, slideShowPtm, getPtmPlanSettingSvc } from './PtmSlideShowSvc';
import SlideshowComponent from './slideShowComponent';

const PtmSlideShowCtrl = () => {
    const search = useLocation().search;
    const ptmId = new URLSearchParams(search).get('ptmId') || 0;

    const [currentComponentIndex, setCurrentComponentIndex] = useState(0);

    const [loader, setLoader] = useState(false);
    const [lstCls, setLstCls] = useState([]);
    const [lstSection, setLstSection] = useState([]);
    const [welcomeObj, setWelcomeObj] = useState({})
    const [lstToppers, setLstToppers] = useState([]);
    const [keyTopper, setKeyTopper] = useState(0)
    const [keySubTchRoom, setKeySubTchRoom] = useState(0)
    const [lstGallery, setLstGallery] = useState([]);
    const [lstAchievement, setLstAchievement] = useState([]);
    const [lstSubTchRoom, setLstSubTchRoom] = useState([]);
    const [lstPtmSetting, setLstPtmSetting] = useState([]);
    const [data, setData] = useState(null)
    const [sectionId, setSectionId] = useState(0);
    const [clsId, setClsId] = useState(0);
    const [basePathPtmToppers, setBasePathPtmToppers] = useState(null)
    const [basePathPtmGallery, setBasePathPtmGallery] = useState(null)
    const [isSlideShowRunning, setIsSlideShowRunning] = useState(false)
    useEffect(() => {
        getClassList();
    }, [])

    const getClassList = () => {
        getClassListSvc(handleClassResponse)
    }
    const handleClassResponse = (data) => {
        if (data.status === 'Success') {
            setLstCls(data.lstCls);
        } else {
            toast.error(data.message);
        }
    };
    function getSlideShowData() {
        slideShowPtm(ptmId, sectionId, cbSlideShowPtm)
    }
    const handleErrorResponse = (data) => {
        toast.error(data.message || 'An error occurred');
        if (data.message === 'You are not logged in' || data.message === 'Your Session is expired, login again') {
            setTimeout(() => {
                window.location.href = '/';
            }, 2000);
        }
    };

    function setSection(handleSectionResponse, clsId) {
        // console.log('getSectionData() called..')
        getSectionData(handleSectionResponse, clsId)
    }

    function handleSectionResponse(data) {
        // console.log(data)
        var obj = data
        if (obj.status == 'Success') {
            setLstSection(obj.lstSection)
            if (obj.lstSection.length > 0) {
                let vSectionId = obj.lstSection[0].sectionId
                setSectionId(vSectionId);

            }
        } else if (obj.status == 'Failure') {
            if (obj.message === 'You are not logged in') {
                setTimeout(function () {
                    window.location.href = '/'
                }, 2000)
                return false
            } else if (obj.message === 'Your Session is expired, login again') {
                setTimeout(function () {
                    window.location.href = '/'
                }, 2000)
                return false
            } else {
                toast.error(obj.message)
            }
        } else {
            toast.error('Service failed ' + obj.message)
        }
    }

    async function changeSection(pSectionId) {
        await setSectionId(pSectionId)
        // slideShowPtm(ptmId, pSectionId, cbSlideShowPtm)
    }

    const cbSlideShowPtm = async (obj) => {
        if (obj.status === 'Success') {
            // console.log(obj)
            setData(obj)
            setWelcomeObj(obj.objWelcome);
            await setLstToppers(obj.lstTopper);
            await setKeyTopper(Math.round(Math.random() * 99999));
            await setBasePathPtmToppers(obj.basePathPtmToppers);
            setBasePathPtmGallery(obj.basePathPtmGallery);
            setLstAchievement(obj.lstAchievement);
            setLstGallery(obj.lstGallery);
            // console.log(obj.lstSubTchRoom)
            await setLstSubTchRoom(obj.lstSubTchRoom);
            await setKeySubTchRoom(Math.round(Math.random() * 99999));
            startSlideshow();

            // Start Slideshow when button is clicked

        } else {
            toast.error(obj.message);
        }
    };
    const startSlideshow = async () => {
        const slidesToDisplay = lstPtmSetting.filter(slide => slide.inUse);
        // setCurrentComponentIndex(0);
        // console.log('slidesToDisplay:', slidesToDisplay)
        await setLstPtmSetting(slidesToDisplay);
        setIsSlideShowRunning(true);
    };
    const getPtmPlanSetting = () => {
        getPtmPlanSettingSvc(ptmId, cbPtmPlanSetting)
    };

    const cbPtmPlanSetting = (data) => {
        if (data.status === 'Success') {
            setLstPtmSetting(data.lstPtmSetting);
        } else {
            toast.error(data.message);
        }
    }


    useEffect(() => {
        getPtmPlanSetting();
        getClassList();
    }, []);


    function changeClass(pClsId, clsLabel) {
        setSectionId(0)
        setClsId(pClsId)
        setSection(pClsId, handleSectionResponse)
    }
    useEffect(() => {
        if (lstPtmSetting.length === 0 || !lstPtmSetting[currentComponentIndex]) return;
        if (isSlideShowRunning && lstPtmSetting.length > 0) {
            // let waitTime = lstPtmSetting[currentComponentIndex]?.waitTime * 1000;
            // console.log(waitTime)
            const intervalId = setInterval(() => {
                setCurrentComponentIndex((prevIndex) => {
                    // console.log(lstPtmSetting.length)
                    let idx = (prevIndex + 1) % lstPtmSetting.length;
                    // console.log('idx', idx, lstPtmSetting[idx])
                    /* if (idx == lstSection.length) {
                        getSlideShowData();
                    } */
                    return idx
                });
            }, lstPtmSetting[currentComponentIndex]?.waitTime * 1000);
            return () => clearInterval(intervalId);
        }
    }, [isSlideShowRunning, currentComponentIndex, lstPtmSetting]);

    const Slide = (props) => {
        <div>{props.children}</div>
    }
    return (
        <div className="MainContainer">
            {loader && (
                <div className="loader" style={{ position: 'fixed', zIndex: 10000 }}>
                    <img className="loaderImg" src={require('common/images/loader.gif')} alt="Loader..." />
                </div>
            )}
            <Header />
            <ToastContainer autoClose={3000} hideProgressBar />
            <div className="col-sm-6 col-centered" style={{ top: '2%', height: 50 }}>
                {lstCls.length > 0 && (
                    <HeaderPtmClassSection
                        changeClass={changeClass}
                        changeSection={changeSection}
                        lstSection={lstSection}
                        lstCls={lstCls}
                        selSectionId={sectionId}
                        classId={clsId}
                    />
                )}
                <button className="btn btn-info" style={{ position: 'absolute', top: '3px', right: '50%' }} title="Play" onClick={() => getSlideShowData()}>Slideshow</button>
            </div>
            {lstPtmSetting && lstPtmSetting.length && isSlideShowRunning && (
                <SlideshowComponent
                    lstPtmSetting={lstPtmSetting}
                    currentComponentIndex={currentComponentIndex}
                    setCurrentComponentIndex={setCurrentComponentIndex}
                    welcomeObj={welcomeObj}
                    ptmId={ptmId}
                    sectionId={sectionId}
                    lstToppers={lstToppers}
                    keyTopper={keyTopper}
                    basePathPtmToppers={basePathPtmToppers}
                    lstSubTchRoom={lstSubTchRoom}
                    keySubTchRoom={keySubTchRoom}
                    lstAchievement={lstAchievement}
                    basePathPtmGallery={basePathPtmGallery}
                    lstGallery={lstGallery}
                />
            )}
        </div>
    );
};

export default PtmSlideShowCtrl;